import React, { useEffect, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import sessionStore from './../../stores/session';
import { Capacitor } from '@capacitor/core';
import songbookSessionStore from './../../stores/songbookSession';
import messageStore from '../../stores/message';
import Alert from './Alert';
import navigationStore from '../../stores/navigation';

function Message(props) {

  const sessionToken = props.isSongbook ? songbookSessionStore((state) => state.sessionToken) : sessionStore((state) => state.sessionToken);
  const currentMessage = messageStore((state) => state.currentMessage);
  const clearMessage = messageStore((state) => state.clearMessage);
  const safeArea = navigationStore((state) => state.safeArea);

  const [messageOpen, setMessageOpen] = useState(true);

  useEffect(function () {
    if (currentMessage && currentMessage.sessionToken === sessionToken) {
      setMessageOpen(true);
    }
  }, [currentMessage]);


  const handleMessageSnackbarClose = (event, reason) => {
    if (reason !== "clickaway") {
      clearMessage();
      setMessageOpen(false);
    }
  };

  const handleMessageAlertClose = (event, reason) => {
    clearMessage();
    setMessageOpen(false);
  };

  const renderMessage = () => {
    if (currentMessage && currentMessage.sessionToken === sessionToken) {
      let isNative = Capacitor.isNativePlatform();
      return <Snackbar open={messageOpen} sx={{ zIndex: 99999999999999999 }} autoHideDuration={6000} onClose={handleMessageSnackbarClose} anchorOrigin={{
        vertical: isNative ? 'top' : 'bottom',
        horizontal: 'center',
      }}>
        <Alert onClose={handleMessageAlertClose} severity="success" sx={{ width: '100%', marginTop: safeArea ? safeArea.top + "px !important" : 0, marginBottom: safeArea ? safeArea.bottom + "px !important" : 0 }}>
          <b>{currentMessage.code} <span>{currentMessage.message}</span></b>
        </Alert>
      </Snackbar>;
    }
  };
  return (
    <div>
      {renderMessage()}
    </div>
  );
}

export default Message;